const IEUserAgent = {
    getVersion: function () {
        // Get the user agent string
        let ua = navigator.userAgent;
        let compatibilityMode = false;


        // Get the current "emulated" version of IE
        let renderVersion = 0;

        // Check the browser version with the rest of the agent string to detect compatibility mode
        if (ua.indexOf("Edge/13") > -1) {
            renderVersion = 13;                  // IE 11
            compatibilityMode = true;
        }
        else if (ua.indexOf("rv:11.0") > -1) {
            renderVersion = 11;                  // IE 11
            compatibilityMode = true;
        }
        else if (ua.indexOf("MSIE 10.0") > -1) {
            renderVersion = 10;                  // IE 10
            compatibilityMode = true;
        }
        else if (ua.indexOf("MSIE 9.0") > -1) {
            this.compatibilityMode = true;
            renderVersion = 9;                   // IE 9
            compatibilityMode = true;
        }

        return { 'version' : renderVersion, 'compatibilityMode' :compatibilityMode};
    }
};

export default IEUserAgent;